import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import AgendaFlow from './AgendaFlow';

type AgendaContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const AgendaContext = createContext<AgendaContextType>({} as AgendaContextType);

export function useAgenda() {
  const context = useContext(AgendaContext);
  if (context === undefined) {
    throw new Error('useAgenda must be used within an AgendaProvider');
  }
  return context;
}

export default function AgendaProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open, close }] = useDisclosure(false);

  return (
    <AgendaContext value={{ opened, open, close }}>
      {children}
      <AgendaFlow opened={opened} close={close} />
    </AgendaContext>
  );
}
